import { ReactNode } from 'react';
import styles from './styles.module.css';

interface Props {
  children?: ReactNode | Iterable<ReactNode>;
}

export default function LayoutWrapper(props: Props) {
	return (
		<div id='layout-wrapper' className={styles['root']}>
			{props.children}
		</div>
	);
}